import { connect } from 'react-redux';
import { compose, setDisplayName, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { usersAction } from '@/actions';

const mapStateToProps = (state) => ({ users: state.users.toJS() });
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...usersAction }, dispatch);

const enhance = compose(
  setDisplayName('UserFollowerItem'),
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    handleUpdateFollow: (props) => async () => {
      const {
        users: { mydata },
        followerId,
        postFollow,
      } = props;
      await postFollow(mydata.id, followerId);
    },
    handleDeleteFollow: (props) => async () => {
      const {
        users: { mydata },
        followerId,
        deleteFollow,
      } = props;

      await deleteFollow(mydata.id, followerId);
    },
  })
);

export default enhance;
